export const FORM_INSERTED_SUCCESS = '@common.form.FORM_INSERTED_SUCCESS';
export const FORM_INSERTED_SUCCESS_NOSCROLL = '@common.form.FORM_INSERTED_SUCCESS_NOSCROLL';
export const FORM_UPDATED_SUCCESS = '@common.form.FORM_UPDATED_SUCCESS';
export const FORM_UPDATED_SUCCESS_NOSCROLL = '@common.form.FORM_UPDATED_SUCCESS_NOSCROLL';
export const FORM_DELETED_SUCCESS = '@common.form.FORM_DELETED_SUCCESS';
export const FORM_DELETED_SUCCESS_NOSCROLL = '@common.form.FORM_DELETED_SUCCESS_NOSCROLL';
export const FORM_REDIRECT = '@common.form.FORM_REDIRECT';
export const FORM_RELOAD = '@common.form.FORM_RELOAD';
export const FORM_RESET = '@common.form.FORM_RESET';
export const FORM_GRID_RELOAD = '@common.form.FORM_GRID_RELOAD';
export const FORM_GRID_RESET = '@common.form.FORM_GRID_RESET';
export const FORM_TREEVIEW_RELOAD = '@common.form.FORM_TREEVIEW_RELOAD';
export const FORM_ASSOCIATE_SUCCESS = '@common.form.FORM_ASSOCIATE_SUCCESS';
export const FORM_MASSASSOCIATE_SUCCESS = '@common.form.FORM_MASSASSOCIATE_SUCCESS';
export const FORM_DISASSOCIATE_SUCCESS = '@common.form.FORM_DISASSOCIATE_SUCCESS';
export const FORM_DISASSOCIATE_SUCCESS_NOSCROLL = '@common.form.FORM_DISASSOCIATE_SUCCESS_NOSCROLL';
export const FORM_INTEGRATION_SUCCESS = '@common.form.FORM_INTEGRATION_SUCCESS';
export const FORM_REJECTION_SUCCESS = '@common.form.FORM_REJECTION_SUCCESS';
export const FORM_EXIGENCIA_SUCCESS = '@common.form.FORM_EXIGENCIA_SUCCESS';
export const FORM_GERADO_SUCCESS = '@common.form.FORM_GERADO_SUCCESS';
export const FORM_IGNORE_SUCCESS = '@common.form.FORM_IGNORE_SUCCESS';
export const FORM_REACTIVED_SUCCESS = '@common.form.FORM_REACTIVED_SUCCESS';
export const FORM_CANCEL_SUCCESS = '@common.form.FORM_CANCEL_SUCCESS';
export const FORM_REACTIVATE_SUCCESS = '@common.form.FORM_REACTIVATE_SUCCESS';
export const FORM_DEFERIDO = '@common.form.FORM_DEFERIDO';
export const RESET_FORM = '@common.form.RESET_FORM';
export const RESET_HASH_FORM = '@common.form.RESET_HASH_FORM';
export const FORM_CIENTIZAR = '@common.form.FORM_CIENTIZAR';
export const FORM_CANCELAR = '@common.form.FORM_CANCELAR';
export const FORM_ERRO = '@common.form.FORM_ERRO';
export const FORM_WARNING = '@common.form.FORM_WARNING';
export const FORM_INFO = '@common.form.FORM_INFO';
export const FORM_GRID_SET_SELECTEDITENS = '@common.form.FORM_GRID_SET_SELECTEDITENS';
export const RESET_FORMCONTROL = '@common.form.RESET_FORMCONTROL';
export const IMAGE_INSERTED_SUCCESS = '@common.form.IMAGE_INSERTED_SUCESS';
export const IMAGE_REMOVED_SUCCESS = '@common.form.IMAGE_REMOVED_SUCESS';
export const FORM_APROVADO_SUCCESS = '@common.form.FORM_APROVADO_SUCCESS';
export const FORM_CANCELADO_SUCCESS = '@common.form.FORM_CANCELADO_SUCCESS';
export const FORM_RECUSADO_SUCCESS = '@common.form.FORM_RECUSADO_SUCCESS';
